import React from 'react'

import styled, { useTheme } from 'styled-components/native'

import { ZoomSelfViewInner } from './ZoomSelfViewInner'
import { VideoIcon } from '../../atoms/icons/VideoIcon'
import { useZoom } from '../../hooks/useZoom/useZoom'
import { Flex1View } from '../../templates/content/CommonViews'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { ZoomSelfPreview } from '../zoomSelfPreview/ZoomSelfPreview'

export type ZoomSelfViewProps = {
  isFullscreen?: boolean
  isFocused?: boolean
}

const EmptyView = styled(Flex1View)(({ theme }) => ({
  backgroundColor: theme.colors.components.zoomSelfView.background,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  alignSelf: 'stretch',
}))

export const ZoomSelfView: React.FC<ZoomSelfViewProps> = ({ isFullscreen, isFocused }) => {
  const { colors } = useTheme() as ThemeType
  const { videoOff, sessionStarted } = useZoom()
  return (
    <>
      {videoOff && (
        <EmptyView testID={tID('ZoomSelfView-empty')}>
          <VideoIcon size={isFullscreen ? 80 : 24} isFilled isMuted fillColor={colors.components.zoomSelfView.text} />
        </EmptyView>
      )}
      {!sessionStarted && <ZoomSelfPreview isFocused={isFocused} />}
      {sessionStarted && <ZoomSelfViewInner />}
    </>
  )
}
